import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BreakpointService {
    public MOBILE_WIDTH = '(max-width: 735px)';
    public DESKTOP_WIDTH = '(min-width: 736px)';
    public MEDIUM_WIDTH = '(max-width: 1198px)';
    public LARGE_WIDTH = '(min-width: 1200px)';

    public constructor(private readonly breakpointObserver: BreakpointObserver) {}

    public isMobileWidth(): Observable<boolean> {
        return this.breakpointObserver
            .observe([this.MOBILE_WIDTH])
            .pipe(map((state: BreakpointState) => state.matches && state.breakpoints[this.MOBILE_WIDTH]));
    }

    public isDesktopWidth(): Observable<boolean> {
        return this.breakpointObserver
            .observe([this.DESKTOP_WIDTH, this.MEDIUM_WIDTH])
            .pipe(map((state: BreakpointState) => state.matches && state.breakpoints[this.MEDIUM_WIDTH]));
    }

    public isLargeWidth(): Observable<boolean> {
        return this.breakpointObserver
            .observe([this.LARGE_WIDTH])
            .pipe(map((state: BreakpointState) => state.matches && state.breakpoints[this.LARGE_WIDTH]));
    }
}
